import { render, staticRenderFns } from "./move-pl-modal.vue?vue&type=template&id=93355b4c&"
import script from "./move-pl-modal.ts?vue&type=script&lang=js&"
export * from "./move-pl-modal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports